var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPostsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,23.3H3V7h9.3V4.3H3C1.5,4.3,0.3,5.5,0.3,7v16c0,1.5,1.2,2.7,2.7,2.7h16c1.5,0,2.7-1.2,2.7-2.7v-9.3H19V23.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,0.3H19v4h-4c0,0,0,2.7,0,2.7h4v4c0,0,2.7,0,2.7,0V7h4V4.3h-4V0.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,9.7H5.7v2.7h10.7V9.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7,13.7v2.7h10.7v-2.7H5.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,17.7H5.7v2.7h10.7V17.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostsMenu);
export default __webpack_public_path__ + "static/media/icon_posts_menu.46b4a3d87f7669c9bcfa65eadd049bc7.svg";
export { ForwardRef as ReactComponent };